module.exports = __webpack_public_path__ + "img/44_2023_07_19.779a3088.jpg";